export default function MarqueeTicker({ t }) {
  const items = t.marqueeItems;
  return (
    <div className="marquee-ticker" data-testid="marquee-ticker">
      <div className="marquee-track">
        <div className="marquee-set">
          {items.map((item, i) => (
            <span className="marquee-item" key={`a-${i}`}>
              {item}
              <span className="marquee-dot" aria-hidden="true">◆</span>
            </span>
          ))}
        </div>
        <div className="marquee-set" aria-hidden="true">
          {items.map((item, i) => (
            <span className="marquee-item" key={`b-${i}`}>
              {item}
              <span className="marquee-dot" aria-hidden="true">◆</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
